import { render, staticRenderFns } from "./SwiperShow.vue?vue&type=template&id=36310cce&scoped=true"
import script from "./SwiperShow.vue?vue&type=script&lang=js"
export * from "./SwiperShow.vue?vue&type=script&lang=js"
import style0 from "./SwiperShow.vue?vue&type=style&index=0&id=36310cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36310cce",
  null
  
)

export default component.exports